import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import dayjs from "dayjs";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { deleteSVG } from "../../../../assets/settings/SVGs";
import { deleteClosedPeriod } from "../../../../network/settings";
import queryClient from "../../../../services/react-query/queryClient";
import { queryKeys } from "../../../../services/react-query/queryKeys";

const Period = ({ data, showModal }: any) => {
  const currentLang = useSelector((state: any) => state?.user?.currentLang);
  const { mutate: DeleteClosedPeriods, isLoading: isLoadingDelete } =
    useMutation(deleteClosedPeriod, {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success("ClosedPeriod deleted");
          queryClient.invalidateQueries([queryKeys.listClosedPeriods]);
        }
      },
    });
  dayjs.locale(currentLang);

  const startDate = dayjs(data.start_date);
  const endDate = dayjs(data.end_date);

  // Format the dates in the desired format
  const formattedStartDate = `${startDate.format("dddd D MMMM")}`;
  const formattedEndDate = `${endDate.format("dddd D MMMM")}`;
  console.log(data, "LocationsLocationsLocationsLocations");

  return (
    <div className="flex flex-col w-full gap-4 p-4 bg-white rounded-lg">
      <div className="flex items-center justify-between">
        <span className="text-color-primary p-2 rounded-lg bg-[#EEF0FF] w-fit">
          {formattedStartDate} - {formattedEndDate}
        </span>
        <div className="flex items-center gap-4">
          <div
            onClick={() => DeleteClosedPeriods(data.id)}
            className={`${
              isLoadingDelete && "opacity-50"
            } cursor-pointer hover:bg-[#EEF0FF] p-1 rounded-lg`}
          >
            {deleteSVG}
          </div>
          <div
            onClick={() => showModal(data)}
            className="cursor-pointer hover:bg-[#EEF0FF] p-1 rounded-lg"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6128 2.89137C12.4956 2.77416 12.3366 2.70831 12.1709 2.70831C12.0051 2.70831 11.8461 2.77416 11.7289 2.89137L4.0686 10.5517C3.99008 10.6302 3.93389 10.7282 3.90583 10.8357L3.07249 14.026C3.01642 14.2407 3.07837 14.469 3.23526 14.6259C3.39216 14.7828 3.62048 14.8448 3.83516 14.7887L7.02551 13.9554C7.13296 13.9273 7.23098 13.8711 7.3095 13.7926L14.9698 6.13228C15.2139 5.8882 15.2139 5.49247 14.9698 5.24839L12.6128 2.89137ZM5.07239 11.3157L12.1709 4.2172L13.644 5.69034L6.54553 12.7888L4.55156 13.3096L5.07239 11.3157Z"
                fill="#9999A7"
              />
              <path
                d="M3.33203 16.0416C2.98685 16.0416 2.70703 16.3215 2.70703 16.6666C2.70703 17.0118 2.98685 17.2916 3.33203 17.2916H15.832C16.1772 17.2916 16.457 17.0118 16.457 16.6666C16.457 16.3215 16.1772 16.0416 15.832 16.0416H3.33203Z"
                fill="#9999A7"
              />
            </svg>
          </div>
        </div>
      </div>
      <div>
        <span className="text-[#75757E] text-sm mx-1">
          <FormattedMessage id="branchesLabel" defaultMessage="Branches:" />
        </span>
        <span>{data.locations.map((e: any) => `${e.name}`).join(" - ")}</span>
      </div>
      <div>
        <span className="text-[#75757E] text-sm mx-1">
          {" "}
          <FormattedMessage
            id="descriptionLabel"
            defaultMessage="Description:"
          />
        </span>
        <span>{data?.description}</span>
      </div>
    </div>
  );
};

export default Period;
